export enum Skill {
  Communication = 'Communication',
  HelpingAndAssisting = 'HelpingAndAssisting',
  DecisionMaking = 'DecisionMaking',
  TaskPerformance = 'TaskPerformance'
}
